import { Form, Spin } from 'antd';

import BackIcon from '@asset/back.icon.svg?react';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { TestIdsEnum } from '@enum/test-ids.enum';
import { NewConsumerForm } from '@form/new-consumer/new-consumer.form';
import { getTestId } from '@util/data/get-test-id';

import { useApplicationSetupConsumer } from './application-setup-consumer.hook';
import {
  ButtonWrapper,
  Description,
  FormWrapper,
  SetupBackButton,
  SetupButton,
  Title,
  Wrapper,
} from './application-setup-consumer.style';

export const ApplicationSetupConsumerPage = () => {
  const { isLoading, form, onFinish, onBack, error } = useApplicationSetupConsumer();

  return (
    <Wrapper>
      <Title level={2} weight={400}>
        Set up a consumer
      </Title>
      <Description>Hit continue if you want to do this later</Description>
      <FormWrapper>
        <Form.Provider onFormFinish={onFinish}>
          <NewConsumerForm error={error} form={form}>
            <Form.Item>
              <ButtonWrapper>
                <SetupBackButton
                  htmlType='button'
                  icon={<BackIcon />}
                  type={ButtonTypeEnum.Primary}
                  block
                  ghost
                  onClick={onBack}
                >
                  Back
                </SetupBackButton>
                <div id='step-6'>
                  <SetupButton
                    htmlType='submit'
                    type={ButtonTypeEnum.Primary}
                    block
                    {...getTestId(TestIdsEnum.CommonButtonSubmit)}
                  >
                    {isLoading && <Spin />}
                    {!isLoading && 'Continue'}
                  </SetupButton>
                </div>
              </ButtonWrapper>
            </Form.Item>
          </NewConsumerForm>
        </Form.Provider>
      </FormWrapper>
    </Wrapper>
  );
};
